import { Button, Flex, Heading, useDisclosure } from '@chakra-ui/react';
import { BuyerOfferAnalysisFragment } from '@client/graphql/__generated__/types';
import { PlusIcon } from 'lucide-react';
import { AddBuyerOfferAnalysisModal } from '../BuyerOfferAnalysis/Modals/AddBuyerOfferAnalysisModal';
import {
  OfferScorecardsContext,
  OfferScorecardsForOrgContextProvider,
} from './OfferScorecardsForOrgContext';
import { OfferScorecardsMetrics } from './OfferScorecardsMetrics';
import { OfferScorecardsTable } from './OfferScorecardsTable';

export const OfferScorecardsForOrg = () => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <OfferScorecardsForOrgContextProvider>
      <Flex
        direction="column"
        gap={4}
        height="100%"
        overflow="hidden"
        width="100%"
      >
        <Flex alignItems="center" justifyContent="space-between">
          <Heading size="sm">Offer Scorecards</Heading>
          <Button leftIcon={<PlusIcon size={16} />} size="xs" onClick={onOpen}>
            New
          </Button>
        </Flex>
        <OfferScorecardsMetrics />
        <OfferScorecardsContext.Consumer>
          {({ scorecard }) => (
            <OfferScorecardsTable
              fetchTriggerRef={scorecard.fetchTriggerRef}
              loading={scorecard.loading}
              offerScorecards={scorecard.rows as BuyerOfferAnalysisFragment[]}
            />
          )}
        </OfferScorecardsContext.Consumer>
      </Flex>
      <AddBuyerOfferAnalysisModal isOpen={isOpen} onClose={onClose} />
    </OfferScorecardsForOrgContextProvider>
  );
};
